<div class="container">
  <div style="height: 120px">
<!--    <img alt="Error image" src="{{appBaseUrl}}/assets/images/Error_500.png">-->
    <mat-icon class="graphic" svgIcon="error"></mat-icon>
  </div>
  <div class="page-title">{{errorMessage}}</div>
  <div class="headline-small">{{errorSubtext}}</div>
</div>
